
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { RequirementsLocation, SaleRequiremenets } from "@/utils/sale-layouts/requirements";
import { v4 } from "uuid";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			selectedLanguage: "",
			editStyle: false,
			radioName: v4()
		};
	},
	props: {
		requirements: Object as () => SaleRequiremenets
	},
	computed: {
		hiddenChecked():boolean {
			return this.requirements.Location == RequirementsLocation.NONE;
		},
		afterTotalsChecked():boolean {
			return this.requirements.Location == RequirementsLocation.AFTER_TOTALS;
		},
		newPageChecked():boolean {
			return this.requirements.Location == RequirementsLocation.NEW_PAGE;
		}
	},
	methods: {
		setHidden(){
			this.requirements.Location = RequirementsLocation.NONE;
		},
		setAfterTotals(){
			this.requirements.Location = RequirementsLocation.AFTER_TOTALS;
		},
		setOnNewPage(){
			this.requirements.Location = RequirementsLocation.NEW_PAGE;
		}
	},
	components: {
		AppStyleEditor,
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
